import { motion } from "framer-motion";
import { CheckCircle, XCircle } from "lucide-react";

const comparisonData = [
  {
    old: "Fighting for a spot on the lake",
    new: "Your reserved cabana waiting for you",
  },
  {
    old: "No shade, no seats, no space",
    new: "Private dock, hammock, BBQ pit included",
  },
  {
    old: "Crowds, chaos, and stress",
    new: "Capacity-limited for your peace of mind",
  },
  {
    old: '"Will we even have fun?"',
    new: '"Best day we\'ve had in years"',
  },
];

const ValueProposition = () => {
  return (
    <section className="py-20 lg:py-28 bg-muted">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Lake Days Shouldn't Be This Hard
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A lake day only works when your space is guaranteed.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Old Way */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-background rounded-2xl p-8 border border-destructive/20"
            >
              <h3 className="font-display text-xl font-semibold text-muted-foreground mb-6 flex items-center gap-2">
                <XCircle className="w-5 h-5 text-destructive" />
                The Old Way
              </h3>
              <ul className="space-y-4">
                {comparisonData.map((item, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="flex items-start gap-3 text-muted-foreground"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-destructive/50 mt-2 flex-shrink-0" />
                    {item.old}
                  </motion.li>
                ))}
              </ul>
            </motion.div>

            {/* Son's Island Way */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-primary rounded-2xl p-8 shadow-glow-primary"
            >
              <h3 className="font-display text-xl font-semibold text-primary-foreground mb-6 flex items-center gap-2">
                <CheckCircle className="w-5 h-5" />
                The Son's Island Way
              </h3>
              <ul className="space-y-4">
                {comparisonData.map((item, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 + index * 0.1 }}
                    className="flex items-start gap-3 text-primary-foreground"
                  >
                    <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                    {item.new}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
